// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4562":"ee3eb9a6","9733":"04979b32"}[chunkId] + ".chunk.css";
};